import { render, staticRenderFns } from "./DowngradeWarning.vue?vue&type=template&id=6442afe8&"
import script from "./DowngradeWarning.vue?vue&type=script&lang=js&"
export * from "./DowngradeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports